import { Button, Form, Input } from 'antd'
import React from "react"
import { useTranslation } from "react-i18next"
import { RouteChildrenProps, useParams } from "react-router"
import { PASSWORD_REGEX } from '../../../../constants/constants'
import { ROUTE_PATHS } from "../../../../constants/url-config"
import { MessageType } from '../../../../models/common/response-message'
import { AuthService } from '../../../../services/auth.service'
import { showMessage } from '../../../atoms/notification/notification'
import "./reset-password.scss"

interface Props extends RouteChildrenProps { }

const ResetPassword = (props: Props) => {
	const { t } = useTranslation();
	const { token } = useParams<{ token: string }>();

	const handleSubmit = async (values: any) => {
		AuthService.resetPassword(token, values.password).then(() => {
			showMessage({ message: t("ForgotPassword.passwordResetSussess"), type: MessageType.success });
			props.history.push(ROUTE_PATHS.Home);
		})
	}

	return (
		<div className="reset-form">
			<div className='header'>
				<p className='big-title'>
					{t('ResetPassword.title')}
				</p>
				<p className='description-text'>
					{t('ResetPassword.welcome')}
				</p>
			</div>
			<Form
				name='resetPassword'
				layout="vertical"
				onFinish={handleSubmit}
			>
				<Form.Item
					label={t('ResetPassword.newPassword')}
					name='password'
					rules={[{ required: true, message: t('ResetPassword.newPasswordRequired') },
					() => ({
						validator(_, value: string) {
							var passwordReg = new RegExp(PASSWORD_REGEX);
							if (!value || passwordReg.test(value)) {
								return Promise.resolve();
							}
							return Promise.reject(t('SignUp.invalidPassword'));
						},
					})]}
				>
					<Input.Password
						iconRender={visible => (visible ? t('Global.hide') : t('Global.show'))}
					/>
				</Form.Item>

				<Form.Item
					label={t('ResetPassword.confirmNewPassword')}
					name='confirmNewPassword'
					rules={[
						{ required: true, message: t('ResetPassword.confirmNewPasswordRequired') },
						({ getFieldValue }) => ({
							validator(_, value) {
								if (!value || getFieldValue('password') === value) {
									return Promise.resolve();
								}
								return Promise.reject(t('ResetPassword.passwordsNotMatch'));
							},
						}),
					]}
				>
					<Input.Password
						iconRender={visible => (visible ? t('Global.hide') : t('Global.show'))}
					/>
				</Form.Item>

				<Form.Item >
					<Button htmlType='submit' type="primary" shape="round">
						{t('ResetPassword.continue')}
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}

export default ResetPassword;